import { render, staticRenderFns } from "./BoilerGarden.vue?vue&type=template&id=505f40da&"
import script from "./BoilerGarden.vue?vue&type=script&lang=js&"
export * from "./BoilerGarden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports